import cookie from 'js-cookie';

type SupportedLanguage =
  | 'da'
  | 'de'
  | 'en'
  | 'es'
  | 'fi'
  | 'fr'
  | 'hu'
  | 'it'
  | 'nl'
  | 'no'
  | 'pl'
  | 'pt'
  | 'sv';

const DEFAULT_LANGUAGE = 'en';
const COOKIE_KEY = 'language';

const LANGUAGE_IMAGES = {
  da: () => import('./images/da.png'),
  de: () => import('./images/de.png'),
  en: () => import('./images/en.png'),
  es: () => import('./images/es.png'),
  fi: () => import('./images/fi.png'),
  fr: () => import('./images/fr.png'),
  hu: () => import('./images/hu.png'),
  it: () => import('./images/it.png'),
  nl: () => import('./images/nl.png'),
  no: () => import('./images/no.png'),
  pl: () => import('./images/pl.png'),
  pt: () => import('./images/pt.png'),
  sv: () => import('./images/sv.png'),
};

const isValidLanguage = (
  language: string | undefined
): language is SupportedLanguage => {
  return language !== undefined && language in LANGUAGE_IMAGES;
};

export const getImageByLang = async () => {
  const currentLanguage = cookie.get(COOKIE_KEY);
  const language = isValidLanguage(currentLanguage)
    ? currentLanguage
    : DEFAULT_LANGUAGE;

  try {
    const imageModule = await LANGUAGE_IMAGES[language]();

    return imageModule.default;
  } catch (error) {
    console.error('img load error:', error);
  }

  return undefined;
};
